import React, { Component, Fragment } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import Logo from './Logo';
import './styles.scss';
import { faThumbtack } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Badge } from 'reactstrap';
import NewOrderButton from './NewOrderButton';

export default withRouter(class Sidebar extends Component {
    render() {
      return (
        <Fragment>
          <div className="sidebar">
            <Logo/>

            <div className="list-unstyled">
              <NewOrderButton/>

              <NavLink to="/my-orders" className="sidebar-item">Мои заказы</NavLink>
              <NavLink to="/my-dealers" className="sidebar-item">Мои поставщики</NavLink>
              <NavLink to="/invoices" className="sidebar-item">Выплаты</NavLink>

              <span className="sidebar-item_pinned"><FontAwesomeIcon icon={faThumbtack}/>&nbsp; Прикрепленные</span>
              <NavLink to="/dropspot" className="sidebar-item __submenu">
                DropSpot
                <Badge color="light" pill className="float-right">1 новое</Badge>

                <div className="sidebar-item_submenu">
                  <div className="sidebar-item">Заказы</div>
                  <div className="sidebar-item">Выплаты</div>
                  <div className="break"></div>
                  <NavLink to="/dropspot/products" className="sidebar-item __full">Товары</NavLink>
                </div>
              </NavLink>
              <NavLink to="/very-well" className="sidebar-item __submenu">
                VeryWell!

                <div className="sidebar-item_submenu">
                  <div className="sidebar-item">Заказы</div>
                  <div className="sidebar-item">Товары</div>
                  <div className="break"></div>
                  <NavLink to="/very-well/products" className="sidebar-item __full">Товары</NavLink>
                </div>
              </NavLink>
            </div>

            <div className="sidebar-footer-button">Помощь</div>
          </div>
        </Fragment>
      );
    }
  }
);
